import request from "@/utils/request";

// 登录请求
export const loginApi = (data) => {
  return request({
    url: "/admin/login",
    method: "post",
    data,
  });
};

export const simpleListApi = (params) => {
  return request({
    url: "/user/simple-list",
    method: "get",
    params
  });
};

// 查询登录日志
export const OperationLog = (params) => {
  return request({
    url: "/user/loadPage",
    method: "get",
    params: params,
  });
};

// 查询账号注销列表及统计
export const getUserDeactivationPage = (params) => {
  return request({
    url: "/user/deactivation/page",
    method: "get",
    params,
  });
};

// 修改密码
export const changePassword = (data) => {
  return request({
    url: "/admin/Change/manage/password",
    method: "post",
    data,
  });
};

// 修改个人信息
export const editUserInfo = (data) => {
  return request({
    url: "/admin/query/user/SetUserinfo",
    method: "post",
    data,
  });
};

// 更新用户超级管理员权限 type: 1为设置为管理员, 0为取消管理员权限
export const setUserAdminApi = (userId, type) => {
  return request({
    url: `/user/setAdmin?userId=${userId}&type=${type}`,
    method: "post",
  });
};

// 创建广场API
export const newSquaerApi = (data) => {
  return request({
    url: "/square/saveOrUpdate",
    method: "post",
    data,
  });
};

// 获取广场列表API
export const GetSquaerApi = (params) => {
  return request({
    url: "/square/page",
    method: "get",
    params: params,
  });
};

export const loadSquareList = () => {
  return request({
    url: "/square/simple-list",
    method: "get",
  });
};

// 修改广场API
export const editSquaerApi = (data) => {
  return request({
    url: "/square/saveOrUpdate",
    method: "post",
    data,
  });
};

// 删除广场API
export const removeSquaerApi = (id) => {
  return request({
    url: `/square/${id}`,
    method: "delete",
  });
};

// 上传头像获取请求头
export const GetOneAuthorization = (data) => {
  return request({
    url: "/admin/GetAuthorization",
    method: "post",
    data,
  });
};

// 创建圈子API
export const AddCircleApi = (data) => {
  return request({
    url: "/circle/saveOrUpdate",
    method: "post",
    data,
  });
};

export const circleDetailApi = (id) => {
  return request({
    url: `/circle/detail/${id}`,
    method: "GET",
  });
};

// 获取圈子列表
export const GetcircleListApi = (params) => {
  return request({
    url: "/circle/page",
    method: "get",
    params,
  });
};

// 删除指定圈子
export const DeleteCircleApi = (id) => {
  return request({
    url: `/circle/${id}`,
    method: "delete",
  });
};

// 获取用户等级列表
export const getUserGradeListApi = (params) => {
  return request({
    url: "/user/level/page",
    method: "get",
    params: params,
  });
};

// 删除指定等级api
export const deleteGradeListApi = (id) => {
  return request({
    url: `/user/level/${id}`,
    method: "delete",
  });
};

// 修改指定等级apii
export const SetUserGradeApi = (data) => {
  return request({
    url: "/user/level/saveOrUpdate",
    method: "post",
    data,
  });
};

// 获取话题列表Api
export const GetSubjectList = (params) => {
  return request({
    url: "/circle/subject/page",
    method: "get",
    params,
  });
};

// 设置话题置顶状态
export const setSubjectApi = (data) => {
  return request({
    url: "/circle/subject/saveOrUpdate",
    method: "post",
    data
  });
};

// 删除话题
export const removeSubject = (id) => {
  return request({
    url: `/circle/subject/${id}`,
    method: "delete",
  });
};

// 新增话题
export const SetSubjectDataApi = (data) => {
  return request({
    url: "/circle/subject/saveOrUpdate",
    method: "post",
    data: data
  });
};

// 获取置顶帖子列表
export const GetTopContentList = (data) => {
  return request({
    url: "/admin/circle/Content/GetTopContentList?pages=" + data,
    method: "get",
  });
};

// 提交帖子置顶状态
export const SetContentTopState = (data) => {
  return request({
    url: "/admin/circle/Content/SetContentTopState" + data,
    method: "get",
  });
};

// 获取帖子列表
export const GetContentListApi = (params) => {
  return request({
    url: "/post/content/page",
    method: "get",
    params,
  });
};

// 通过帖子ID获取帖子详细信息
export const GetContentDetailsData = (data) => {
  return request({
    url: "/post/content/page",
    method: "get",
    params: {
      pageNum: 1,
      pageSize: 1,
      contentId: data,
    },
  }).then(res => {
    return {
      ...res,
      data: res.data?.records?.[0] || null,
    }
  });
};

// 批量提交审核
export const setContentExamineResult = (data) => {
  return request({
    url:
      "/post/content/setContentExamineResult",
    method: "post",
    data,
  });
};

// 帖子审核
export const addSetContentExamineResult = (data) => {
  return request({
    url: "/admin/circle/Content/SetContentExamineResult?ContentID=" + data,
    method: "get",
  });
};

// 搜索帖子
export const QueryPointContentList = (data) => {
  return request({
    url: "/admin/circle/Content/QueryPointContentList?pages=" + data,
    method: "get",
  });
};

// 搜索置顶帖子
export const QueryPointTopContentList = (data) => {
  return request({
    url: "/admin/circle/Content/QueryPointTopContentList?pages=" + data,
    method: "get",
  });
};

// 搜索指定话题
export const QueryPointSubjectList = (data) => {
  return request({
    url: "/admin/circle/subject/QueryPointSubjectList?pages=" + data,
    method: "get",
  });
};

// 获取装扮列表
export const GetDecorationList = (params) => {
  return request({
    url: "/points/mall/page",
    method: "get",
    params,
  });
};

// 新增装扮列表
export const SetNewDecoration = (data) => {
  return request({
    url: "/points/mall/saveOrUpdate",
    method: "post",
    data,
  });
};

// 删除装扮Api
export const DeleteDecoration = (id) => {
  return request({
    url: `/points/mall/${id}`,
    method: "delete",
  });
};

// 修改装扮Api
export const SetModifyDecoration = (data, ID) => {
  return request({
    url: "/admin/pointsmall/Decoration/SetModifyDecoration?ID=" + ID,
    method: "post",
    data,
  });
};

// 获取邀请好友码配置API
export const getInvitefriendsInfoApi = () => {
  return request({
    url: "/setting/share/reward",
    method: "get",
  });
};

// 提交邀请好友码配置API
export const setInvitefriendsInfoApi = (data) => {
  return request({
    url: "/setting/share/reward",
    method: "post",
    data,
  });
};

// 消息列表
export const getMessageListApi = (params) => {
  return request({
    url: "/message/page",
    method: "get",
    params,
  });
};

// 站内提醒分页查询
export const getNoticeListApi = (params) => {
  return request({
    url: "/message/notice/page",
    method: "get",
    params,
  });
}

export const readNotice = (params) =>{
  return request({
    url: "/message/notice/read",
    method: "put",
    params
  })
}

// 未读站内提醒总数
export const getUnreadNoticeCountApi = () => {
  return request({
    url: "/message/notice/unread/count",
    method: "get",
  });
}

// 删除站内信息
export const deleteNotice = (id) => {
  return request({
    url: "/message/notice/delete?id=" + id,
    method: "post",
  });
}
